import { PAGE_SIZE } from "../../../services/common/const";
import { Parameter, ResultData } from "./OPDClinical.types";

export const parameters: Parameter = {
  prescriptionId: "",
  pageIndex: 1,
  pageSize: PAGE_SIZE,
  sortColumn: "",
  sortDirection: "",
  searchValue: "",
  tabType: 0,
  departmentIds: [],
  specialityIds: [],
  doctorIds: [],
  locationIds: [],
  startDate: "",
  endDate: "",
};

export const initResultData: ResultData = {
  opdColl: [],
  tabTypeColl: [],
  activeCaseColl: [],
  totalCount: 0,
};

export const tabs = [
  {
    index: 0,
    value: "SCHEDULED",
    label: "Scheduled",
    style: { backgroundColor: "#787d81", color: "#fff" },
  },
  {
    index: 1,
    value: "WAITING",
    label: "Waiting",
    style: { backgroundColor: "#787d81", color: "#fff" },
  },
  {
    index: 2,
    value: "ACTIVE",
    label: "Active",
    style: { backgroundColor: "#c19603", color: "#fff" },
  },
  {
    index: 3,
    value: "COMPLETE",
    label: "Complete",
    style: { backgroundColor: "#448944", color: "#fff" },
  },
  {
    index: 4,
    value: "ALL",
    label: "All",
    style: {
      backgroundColor: "black",
      color: "#fff",
    },
  },
];

export const skeletonRowCount = 3;
export const maxWhatsappLoginRetry = 1;

export const VISIT_COMPLETION_TEMPLATE_MAP: any = {
  WITH_PRESCRIPTION: {
    label: "With Prescription",
    languages: {
      gujarati: {
        templateName: "gujarati_visit_completion_notification",
        langCode: "gu",
        parameters: [
          "patientName",
          "consultingDoctorName",
          "organizationName",
          "appointmentLink",
          "branchMobile",
          "fullPrescriptionUrl",
        ],
      },
      hindi: {
        templateName: "hindi_visit_completion",
        langCode: "hi",
        parameters: [
          "patientName",
          "consultingDoctorName",
          "organizationName",
          "appointmentLink",
          "branchMobile",
          "fullPrescriptionUrl",
        ],
      },
      english: {
        templateName: "visit_completion_notification",
        langCode: "en",
        parameters: [
          "patientName",
          "consultingDoctorName",
          "organizationName",
          "appointmentLink",
          "branchMobile",
          "fullPrescriptionUrl",
        ],
      },
    },
  },
  WITHOUT_PRESCRIPTION: {
    label: "Without Prescription (Thank You)",
    languages: {
      gujarati: {
        templateName: "thank_you_for_visit_gujarati",
        langCode: "gu",
        parameters: [
          "patientName",
          "consultingDoctorName",
          "organizationName",
          "branchMobile",
          "fullAppointmentUrl",
        ], // "fullAppointmentUrl"
      },
      hindi: {
        templateName: "thank_you_for_visit",
        langCode: "hi",
        parameters: [
          "patientName",
          "consultingDoctorName",
          "organizationName",
          "branchMobile",
          "fullAppointmentUrl",
        ], // "fullAppointmentUrl"
      },
      english: {
        templateName: "visit_completion_without_prescription_english",
        langCode: "en",
        parameters: [
          "patientName",
          "consultingDoctorName",
          "organizationName",
          "branchMobile",
          "fullAppointmentUrl",
        ], // "fullAppointmentUrl"
      },
    },
  },
  WITH_PRESCRIPTION_AND_BILL: {
    label: "With Prescription and Bill",
    languages: {
      gujarati: {
        templateName: "guj_with_bill_and_prescription_visit_completion",
        langCode: "gu",
        parameters: [
          "patientName",
          "consultingDoctorName",
          "organizationName",
          "appointmentLink",
          "branchMobile",
          "fullPrescriptionUrl",
          "billingUrl",
        ],
      },
      hindi: {
        templateName: "hindi_prescription_and_bill_visit_completion",
        langCode: "hi",
        parameters: [
          "patientName",
          "consultingDoctorName",
          "organizationName",
          "appointmentLink",
          "branchMobile",
          "fullPrescriptionUrl",
          "billingUrl",
        ],
      },
      english: {
        templateName: "eng_prescription_and_bill_visit_completion",
        langCode: "en",
        parameters: [
          "patientName",
          "consultingDoctorName",
          "organizationName",
          "appointmentLink",
          "branchMobile",
          "fullPrescriptionUrl",
          "billingUrl",
        ],
      },
    },
  },
};

export const REFERRAL_VISIT_COMPLETION_TEMPLATE_MAP: any = {
  WITH_PRESCRIPTION: {
    label: "With Prescription",
    languages: {
      english: {
        templateName: "referral_patient_received_notification",
        langCode: "en",
        parameters: [
          "referredByName",
          "patientName",
          "organizationName",
          "consultingDoctorName",
          "diagnosisSummary",
          "fullPrescriptionLink",
          "referralBookLink",
        ],
      },
    },
  },
  WITHOUT_PRESCRIPTION: {
    label: "Without Prescription",
    languages: {
      english: {
        templateName: "referral_patient_received_notification_without_link",
        langCode: "en",
        parameters: [
          "referredByName",
          "patientName",
          "organizationName",
          "consultingDoctorName",
          "diagnosisSummary",
          "referralBookLink",
        ],
      },
    },
  },
};

export const zoomOptions = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];

// ── Status Transition WhatsApp Templates ──────────────────────────────────────
// Sent automatically when patient moves between OPD statuses
export const STATUS_TRANSITION_TEMPLATE_MAP: any = {
  // SCHEDULED → WAITING: patient added to waiting list
  SCHEDULED_TO_WAITING: {
    languages: {
      gujarati: {
        templateName: "gujarati_welcome_message",
        langCode: "gu",
        parameters: [
          "patientName",
          "consultingDoctorName",
          "organizationName",
          "appointmentNumber",
        ],
      },
      hindi: {
        templateName: "hindi_welcome_message",
        langCode: "hi",
        parameters: [
          "patientName",
          "consultingDoctorName",
          "organizationName",
          "appointmentNumber",
        ],
      },
      english: {
        templateName: "eng_welcome_to_hospital_message",
        langCode: "en",
        parameters: [
          "patientName",
          "consultingDoctorName",
          "organizationName",
          "appointmentNumber",
        ],
      },
    },
  },
  // WAITING → ACTIVE: patient called in for consultation
  WAITING_TO_CONSULTING: {
    languages: {
      gujarati: {
        templateName: "gujarati_check_in_message",
        langCode: "gu",
        parameters: ["patientName", "organizationName", "consultingDoctorName"],
      },
      hindi: {
        templateName: "hindi_check_in",
        langCode: "hi",
        parameters: ["patientName", "organizationName", "consultingDoctorName"],
      },
      english: {
        templateName: "eng_check_in",
        langCode: "en",
        parameters: ["patientName", "organizationName", "consultingDoctorName"],
      },
    },
  },
  // ACTIVE → COMPLETE: consultation done
  CONSULTING_TO_COMPLETE: {
    languages: {
      gujarati: {
        templateName: "thank_you_for_visit_gujarati",
        langCode: "gu",
        parameters: [
          "patientName",
          "consultingDoctorName",
          "organizationName",
          "branchMobile",
          "appointmentUrl",
        ],
      },
      hindi: {
        templateName: "thank_you_for_visit_hindi",
        langCode: "hi",
        parameters: [
          "patientName",
          "consultingDoctorName",
          "organizationName",
          "branchMobile",
          "appointmentUrl",
        ],
      },
      english: {
        templateName: "thank_you_for_visit_english",
        langCode: "en",
        parameters: [
          "patientName",
          "consultingDoctorName",
          "organizationName",
          "branchMobile",
          "appointmentUrl",
        ],
      },
    },
  },
};

export const VISIT_SCHEDULE_TEMPLATE_MAP: any = {
  gujarati: {
    templateName: "gujarati_scheduled_appointment_reminder",
    langCode: "gu",
    parameters: [
      "patientName",
      "consultingDoctorName",
      "organizationName",
      "appointmentDateTime",
      "branchMobile",
      "appointmentUrl",
    ],
  },
  hindi: {
    templateName: "hindi_schedule_appointment_reminder",
    langCode: "hi",
    parameters: [
      "patientName",
      "consultingDoctorName",
      "organizationName",
      "appointmentDateTime",
      "branchMobile",
      "appointmentUrl",
    ],
  },
  english: {
    templateName: "english_schedule_appointment_reminder",
    langCode: "en",
    parameters: [
      "patientName",
      "consultingDoctorName",
      "organizationName",
      "appointmentDateTime",
      "branchMobile",
      "appointmentUrl",
    ],
  },
};

export const VISIT_CANCELLATION_TEMPLATE_MAP: any = {
  gujarati: {
    templateName: "reschedule_appointment_gujarati",
    langCode: "gu",
    parameters: [
      "patientName",
      "consultingDoctorName",
      "organizationName",
      "appointmentDate",
      "branchMobile",
      "appointmentUrl",
    ],
  },
  hindi: {
    templateName: "reschedule_appointment_hindi",
    langCode: "hi",
    parameters: [
      "patientName",
      "consultingDoctorName",
      "organizationName",
      "appointmentDate",
      "branchMobile",
      "appointmentUrl",
    ],
  },
  english: {
    templateName: "reschedule_your_appointment",
    langCode: "en",
    parameters: [
      "patientName",
      "consultingDoctorName",
      "organizationName",
      "appointmentDate",
      "branchMobile",
      "appointmentUrl",
    ],
  },
};
